import React from 'react'; 
import './Team.css'; 

import { Heading, TeamItem } from '../../../components';
import { teamContent } from '../../../constants';
 
    
  
const Team = () => { 
  return (
    <section className='team'>
 
      {/* Section heading */}
      <Heading title={'our team'} span={'Meet Our Team'} />

      <div className='box-container'> 
      { 
        // Map over the teamContent array to render each team member
        teamContent.map((team) => { 
        return(
          <TeamItem 
            key={team.id}
            team={team}  
          />)
        })
      } 
      </div>

    </section>
  )
}

export default Team;